import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { MaintenanceService } from '../services/maintenance/maintenance.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private localizeRouterService: LocalizeRouterService,
    private maintenanceService: MaintenanceService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkMaintenance();
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkMaintenance();
  }

  private checkMaintenance(): boolean | UrlTree {
    if (this.maintenanceService.isMaintenanceActive()) {
      const localized = this.localizeRouterService?.translateRoute('/maintenance') as string | undefined;
      const url = localized && typeof localized === 'string' ? localized : 'fr/maintenance';
      return this.router.parseUrl(url);
    }
    return true;
  }
}
